module.exports = __webpack_public_path__ + "img/img5.4913c403.svg";